
import { tokens } from "../../theme/theme";
import { Typography, Card, CardContent, Grid, Button, useTheme, Box, } from "@mui/material";

// icons 
import LooksOutlinedIcon from '@mui/icons-material/LooksOutlined';
import { useTranslation } from "react-i18next";
import { AddBoxOutlined, DashboardCustomize, DashboardOutlined, Pin, Report, ReportOffOutlined, ViewAgenda, Warehouse } from "@mui/icons-material";
import BusinessIcon from '@mui/icons-material/Business';
import NatureIcon from '@mui/icons-material/Nature';
import PlaceIcon from '@mui/icons-material/Place';
import CategoryIcon from '@mui/icons-material/Category';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import MapIcon from '@mui/icons-material/Map';
import useUserPermissions from "../../components/user-permission/UserPermission";
import { hasPermission } from "../../components/user-permission/AuthorizationParameter";
import { useState } from "react";
const WarehouseNewManagementMenu = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();
    const userPermissions = useUserPermissions();
    const [xlValue, setXLValue] = useState(2);

    const callback = () => {
        handleBackDashboard();
    };

    return (
        <Box >
            <Card sx={{ backgroundColor: "transparent", borderRadius: "0px", height: "48px" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center" >
                        <Typography variant="h5" color={colors.grey[100]} fontWeight="bold" justifyContent="center">Warehouse Management </Typography>
                    </Box>
                </CardContent>
            </Card>

            {/* <Divider /> */}
            {/* <Box p={2}>
                <Grid container spacing={2} justifyContent="start" marginTop="10px"  >
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <LooksOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>List Of warehouse</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("Warehouse")}>View</Button>
                        </Card>
                    </Grid>
                </Grid>
            </Box> */}




            <Box p={2}>
                <Grid container spacing={2} justifyContent="flex-start" >


                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <Card
                            onClick={() => SetActive("WarehouseDashboard")}
                            elevation={3}
                            sx={{
                             background: "linear-gradient(135deg, #283593 30%, #1E88E5 90%)", // standout gradient
                          //  background: "linear-gradient(135deg, #00695c 30%, #26a69a 90%)",

                                color: "#fff",
                                borderRadius: 3,
                                p: 3,
                                textAlign: "center",
                                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                "&:hover": {
                                    transform: "translateY(-5px)",
                                    boxShadow: theme.shadows[6],
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    mx: "auto",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "rgba(255, 255, 255, 0.15)",
                                    borderRadius: "50%",
                                    mb: 2,
                                }}
                            >
                                <DashboardOutlined fontSize="large" sx={{ color: "#fff" }} />
                            </Box>
                            <Typography variant="h6" fontWeight={600}>
                                Warehouse Dashboard
                            </Typography>
                            <Button
                                variant="contained"
                                sx={{
                                    mt: 2,
                                    backgroundColor: "#fff",
                                    color: "#1E88E5",
                                    "&:hover": { backgroundColor: "#f1f1f1" },
                                }}
                                onClick={() => SetActive("WarehouseDashboard")}
                            >
                                Open
                            </Button>
                        </Card>
                    </Grid>



                    {hasPermission(userPermissions, "Warehouse type", "Enabled") && (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                            <Card
                                elevation={3}
                                sx={{
                                    backgroundColor: colors.primary[400],
                                    //theme.palette.background.paper,
                                    borderRadius: 3,
                                    p: 3,
                                    textAlign: "center",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        boxShadow: theme.shadows[6],
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        mx: "auto",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: colors.primary[400],
                                        // theme.palette.secondary.light,
                                        borderRadius: "50%",
                                        mb: 2,
                                    }}
                                >
                                    <BusinessIcon fontSize="large" color="secondary"  />
                                </Box>
                                <Typography variant="h6" fontWeight={600}>
                                    Warehouse Types
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{ mt: 2 }}
                                    onClick={() => SetActive("WarehouseType")}
                                >
                                    Create
                                </Button>


                            </Card>
                        </Grid>)}

                    {hasPermission(userPermissions, "Warehouse environment type", "Enabled") && (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                            <Card
                                elevation={3}
                                sx={{
                                    backgroundColor: colors.primary[400],
                                    //theme.palette.background.paper,
                                    borderRadius: 3,
                                    p: 3,
                                    textAlign: "center",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        boxShadow: theme.shadows[6],
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        mx: "auto",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: colors.primary[400],
                                        // theme.palette.secondary.light,
                                        borderRadius: "50%",
                                        mb: 2,
                                    }}
                                >
                                    <NatureIcon fontSize="large" color="secondary" />
                                </Box>
                                <Typography variant="h6" fontWeight={600}>
                                    Environment Types
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{ mt: 2 }}
                                    onClick={() => SetActive("WarehouseEnvironmentType")}
                                >
                                    Create
                                </Button>
                            </Card>
                        </Grid>
                    )}



                    {hasPermission(userPermissions, "Location type", "Enabled") && (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                            <Card
                                elevation={3}
                                sx={{
                                    backgroundColor: colors.primary[400],
                                    //theme.palette.background.paper,
                                    borderRadius: 3,
                                    p: 3,
                                    textAlign: "center",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        boxShadow: theme.shadows[6],
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        mx: "auto",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: colors.primary[400],
                                        // theme.palette.secondary.light,
                                        borderRadius: "50%",
                                        mb: 2,
                                    }}
                                >
                                    <PlaceIcon fontSize="large" color="secondary" />
                                </Box>
                                <Typography variant="h6" fontWeight={600}>
                                    Location Types
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{ mt: 2 }}
                                    onClick={() => SetActive("WarehouseLocationType")}
                                >
                                    Create
                                </Button>
                            </Card>
                        </Grid>)}


                    {hasPermission(userPermissions, "Object type", "Enabled") && (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                            <Card
                                elevation={3}
                                sx={{
                                    backgroundColor: colors.primary[400],
                                    //theme.palette.background.paper,
                                    borderRadius: 3,
                                    p: 3,
                                    textAlign: "center",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        boxShadow: theme.shadows[6],
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        mx: "auto",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: colors.primary[400],
                                        // theme.palette.secondary.light,
                                        borderRadius: "50%",
                                        mb: 2,
                                    }}
                                >
                                    <CategoryIcon fontSize="large" color="secondary" />
                                </Box>
                                <Typography variant="h6" fontWeight={600}>
                                    Object Types
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{ mt: 2 }}
                                    onClick={() => SetActive("WarehouseObjectSizeType")}
                                >
                                    Create
                                </Button>
                            </Card>
                        </Grid>)}

                    {hasPermission(userPermissions, "Warehouse master", "Enabled") && (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                            <Card
                                elevation={3}
                                sx={{
                                    backgroundColor: colors.primary[400],
                                    //theme.palette.background.paper,
                                    borderRadius: 3,
                                    p: 3,
                                    textAlign: "center",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        boxShadow: theme.shadows[6],
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        mx: "auto",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: colors.primary[400],
                                        // theme.palette.secondary.light,
                                        borderRadius: "50%",
                                        mb: 2,
                                    }}
                                >
                                    <WarehouseIcon fontSize="large" color="secondary" />
                                </Box>
                                <Typography variant="h6" fontWeight={600}>
                                    Warehouse Master
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{ mt: 2 }}
                                    onClick={() => SetActive("Warehouse")}
                                >
                                    View
                                </Button>
                            </Card>
                        </Grid>

                    )}


                    {hasPermission(userPermissions, "Bin type", "Enabled") && (

                        <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                            <Card
                                elevation={3}
                                sx={{
                                    backgroundColor: colors.primary[400],
                                    //theme.palette.background.paper,
                                    borderRadius: 3,
                                    p: 3,
                                    textAlign: "center",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        boxShadow: theme.shadows[6],
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        mx: "auto",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: colors.primary[400],
                                        // theme.palette.secondary.light,
                                        borderRadius: "50%",
                                        mb: 2,
                                    }}
                                >
                                    <Inventory2Icon fontSize="large" color="secondary" />
                                </Box>
                                <Typography variant="h6" fontWeight={600}>
                                    Bin Types
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{ mt: 2 }}
                                    onClick={() => SetActive("BinTypeMaster")}
                                >
                                    Create
                                </Button>
                            </Card>
                        </Grid>)}

                    {hasPermission(userPermissions, "Storage Location", "Enabled") && (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                            <Card
                                elevation={3}
                                sx={{
                                    backgroundColor: colors.primary[400],
                                    //theme.palette.background.paper,
                                    borderRadius: 3,
                                    p: 3,
                                    textAlign: "center",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        boxShadow: theme.shadows[6],
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        mx: "auto",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: colors.primary[400],
                                        // theme.palette.secondary.light,
                                        borderRadius: "50%",
                                        mb: 2,
                                    }}
                                >
                                    <MapIcon fontSize="large" color="secondary" />
                                </Box>
                                <Typography variant="h6" fontWeight={600}>
                                    Storage Location
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{ mt: 2 }}
                                    onClick={() => SetActive("StorageLocation")}
                                >
                                    Update
                                </Button>
                            </Card>
                        </Grid>)}

                    {hasPermission(userPermissions, "Warehouse Mapping", "Enabled") && (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                            <Card
                                elevation={3}
                                sx={{
                                    backgroundColor: colors.primary[400],
                                    //theme.palette.background.paper,
                                    borderRadius: 3,
                                    p: 3,
                                    textAlign: "center",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        boxShadow: theme.shadows[6],
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        mx: "auto",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: colors.primary[400],
                                        // theme.palette.secondary.light,
                                        borderRadius: "50%",
                                        mb: 2,
                                    }}
                                >
                                    <LooksOutlinedIcon fontSize="large" color="secondary" />
                                </Box>
                                <Typography variant="h6" fontWeight={600}>
                                    Warehouse Mapping
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{ mt: 2 }}
                                    onClick={() => SetActive("WarehouseMapping")}
                                >
                                    Update
                                </Button>
                            </Card>
                        </Grid>)}

                    {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card
                            elevation={3}
                            sx={{
                                backgroundColor: colors.primary[400],
                                //theme.palette.background.paper,
                                borderRadius: 3,
                                p: 3,
                                textAlign: "center",
                                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                "&:hover": {
                                    transform: "translateY(-5px)",
                                    boxShadow: theme.shadows[6],
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    mx: "auto",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: colors.primary[400],
                                    // theme.palette.secondary.light,
                                    borderRadius: "50%",
                                    mb: 2,
                                }}
                            >
                                <ViewAgenda fontSize="large" color="secondary" />
                            </Box>
                            <Typography variant="h6" fontWeight={600}>
                                Warehouse Report
                            </Typography>
                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{ mt: 2 }}
                                onClick={() => SetActive("WarehouseReport")}
                            >
                                Update
                            </Button>
                        </Card>
                    </Grid> */}


                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <Card
                            elevation={3}
                            sx={{
                                backgroundColor: colors.primary[400],
                                //theme.palette.background.paper,
                                borderRadius: 3,
                                p: 3,
                                textAlign: "center",
                                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                "&:hover": {
                                    transform: "translateY(-5px)",
                                    boxShadow: theme.shadows[6],
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    mx: "auto",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: colors.primary[400],                                   
                                    borderRadius: "50%",
                                    mb: 2,
                                }}
                            >
                                <ViewAgenda fontSize="large" color="secondary" />
                            </Box>
                            <Typography variant="h6" fontWeight={600}>
                                Warehouse master Report
                            </Typography>
                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{ mt: 2 }}
                                onClick={() => SetActive("WarehouseMasterReport")}
                            >
                                Update
                            </Button>
                        </Card>
                    </Grid>


                     {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card
                            elevation={3}
                            sx={{
                                backgroundColor: colors.primary[400],
                                //theme.palette.background.paper,
                                borderRadius: 3,
                                p: 3,
                                textAlign: "center",
                                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                "&:hover": {
                                    transform: "translateY(-5px)",
                                    boxShadow: theme.shadows[6],
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    mx: "auto",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: colors.primary[400],
                                    // theme.palette.secondary.light,
                                    borderRadius: "50%",
                                    mb: 2,
                                }}
                            >
                                <ViewAgenda fontSize="large" color="secondary" />
                            </Box>
                            <Typography variant="h6" fontWeight={600}>
                                userGude
                            </Typography>
                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{ mt: 2 }}
                                onClick={() => SetActive("user-guide")}
                            >
                                Update
                            </Button>
                        </Card>
                    </Grid> */}


                </Grid>

            </Box>






        </Box>

    )
}
export default WarehouseNewManagementMenu;